import { render, staticRenderFns } from "./OutDcmntBepr.vue?vue&type=template&id=5c49c952&"
import script from "./OutDcmntBepr.vue?vue&type=script&lang=js&"
export * from "./OutDcmntBepr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports